export let indicator = {
  bindings: {
    fraction: '<',
    description: '<',
    total: '<',
    indicatorCount: '<',
    onClick: '&',
    selected: '<'
  },
  template: `
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="principal-diagram c100 p{{vm.percentageRound}} {{vm.selected? 'md' : vm.gaugeClass}} green center">
          <span class="pointer" ng-click=vm.onClick()>{{ vm.percentage }}%</span>
          <div class="slice">
            <div class="bar"></div>
            <div class="fill"></div>
          </div>                  
        </div>
        <p class="{{vm.textClass}} exo p-t text-blanco">{{ vm.fraction }}/{{ vm.total }}</p>
        <p class="{{vm.textClass}} text-blanco">{{ vm.description[0] }}<br>{{ vm.description[1] }}</p>
      </div>
    </div>`,
  controllerAs: 'vm',
  controller: [
  function indicatorCtrl () {
    const vm = this
    vm.percentage = null
    let nonZeroTotal = vm.total === 0 ? 1 : vm.total

    vm.$onInit = () => {
      switch (vm.indicatorCount) {
        case 4: {
          vm.textClass = 'text-sm'
          vm.gaugeClass = 'sm'
          break
        }
        case 5: {
          vm.textClass = 'text-xs'
          vm.gaugeClass = 'xs'
          break
        }
      }
      vm.percentage = ((vm.fraction / nonZeroTotal) * 100).toFixed(1)
      vm.percentageRound = Math.round(vm.percentage)
      Number(vm.fraction)
      Number(vm.total)
    }
  }
  ]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/list-panel/indicator.js